package fr.frux.shared.domain.model

/**
 * Profil public d'un contributeur (#227) : ce que n'importe qui peut voir d'un autre compte.
 * Jamais d'email — c'est ce qui le distingue de [User], réservé au porteur de la session.
 */
data class UserProfile(
    val id: Long,
    val username: String,
    val treesCount: Int,
    val harvestsCount: Int,
    val createdAt: Long,
    /** L'utilisateur courant masque ce compte (#515). Toujours faux sans session. */
    val blockedByMe: Boolean = false,
)
